import { render, staticRenderFns } from "./CPRadioGroup.vue?vue&type=template&id=08df4828&scoped=true&"
import script from "./CPRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./CPRadioGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CPRadioGroup.vue?vue&type=style&index=0&id=08df4828&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08df4828",
  null
  
)

export default component.exports